
import { deleteactapis } from './httpHeaderInterceptor';


export async function sendOtpToDelete(reqobj) {
    try {
        const response = await deleteactapis.post('/user/sendOtpToDelete', reqobj);
        const ResponseData = response.data;
        if (!response.statusText === "OK") {
            throw new Error('request failed');
        }
        return ResponseData;

    } catch (error) {
        //console.error('Login failed:', error);
        throw error;
    }
}


export async function verifyOtpToDelete(reqobj) {
    try {
        const response = await deleteactapis.post('/user/verifyOtpToDelete', reqobj);
        const ResponseData = response.data;
        // sessionStorage.setItem('user', JSON.stringify(ResponseData));
        // sessionStorage.setItem('role', loginResponseData.role);
        if (!response.statusText === "OK") {
            throw new Error('Login request failed');
        }
        // Handle the response data
        //console.log('Login successful service', loginResponseData);
        return ResponseData;

    } catch (error) {
        //console.error('Login failed:', error);
        throw error;
    }
}